export default __webpack_public_path__ + "static/media/gif_nothing-to-see-here.da54f93e.gif";